"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _qs = _interopRequireDefault(require("qs"));

var _useRedirect = _interopRequireDefault(require("@sprinx/react-routes/useRedirect"));

var _useRouteLocation = _interopRequireDefault(require("@sprinx/react-routes/useRouteLocation"));

var defaultFilterState = {};
var defaultState = {
  filter: defaultFilterState,
  order: 'default',
  pagination: {
    rowsPerPage: 12,
    page: 1
  },
  stockOnly: false
};

var stringyState = function stringyState(s) {
  return "?".concat(_qs.default.stringify({
    filter: s.filter,
    pagination: s.pagination.page > 1 || s.pagination.rowsPerPage !== 12 ? s.pagination : undefined,
    order: s.order === 'default' ? undefined : s.order,
    stockOnly: s.stockOnly || undefined
  }));
};

function useProductListState(taxonomyCode, listRef) {
  var setRedirect = (0, _useRedirect.default)();
  var location = (0, _useRouteLocation.default)();
  var initialState = (0, _extends2.default)({}, defaultState, _qs.default.parse((location.search || '?').substring(1)), {
    prevTaxonomyCode: taxonomyCode
  });

  var _React$useState = _react.default.useState(initialState),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      _React$useState2$ = _React$useState2[0],
      filter = _React$useState2$.filter,
      order = _React$useState2$.order,
      pagination = _React$useState2$.pagination,
      prevTaxonomyCode = _React$useState2$.prevTaxonomyCode,
      stockOnly = _React$useState2$.stockOnly,
      setState = _React$useState2[1];

  var setStateAndQuery = _react.default.useCallback(function (reducer) {
    return setState(function (ps) {
      var ns = reducer(ps);
      var nextQuery = stringyState(ns);

      if (nextQuery !== stringyState(ps)) {
        setRedirect(nextQuery, {}, false);
      }

      return ns;
    });
  }, [setRedirect]);

  var handleChangePage = _react.default.useCallback(function (nextPage) {
    setStateAndQuery(function (ps) {
      return (0, _extends2.default)({}, ps, {
        pagination: (0, _extends2.default)({}, ps.pagination, {
          page: nextPage + 1
        })
      });
    });
    window.scrollTo({
      top: listRef.current.offsetTop
    });
  }, [listRef, setStateAndQuery]);

  var handleChangeRowsPerPage = _react.default.useCallback(function (nextRowsPerPage) {
    setStateAndQuery(function (ps) {
      return (0, _extends2.default)({}, ps, {
        pagination: {
          page: 1,
          rowsPerPage: nextRowsPerPage
        }
      });
    });
  }, [setStateAndQuery]);

  var handleChangeFilter = _react.default.useCallback(function (nextFilter) {
    setStateAndQuery(function (prevState) {
      return (0, _extends2.default)({}, prevState, {
        filter: nextFilter
        /* , pagination: { ...prevState.pagination, page: 1 } */

      });
    });
  }, [setStateAndQuery]);

  var handleChangeStockOnly = _react.default.useCallback(function (nextStockOnly) {
    setStateAndQuery(function (ps) {
      return (0, _extends2.default)({}, ps, {
        stockOnly: nextStockOnly
      });
    });
  }, [setStateAndQuery]);

  var handleResetFilter = _react.default.useCallback(function () {
    setStateAndQuery(function (prevState) {
      return (0, _extends2.default)({}, prevState, {
        filter: defaultFilterState,
        pagination: (0, _extends2.default)({}, prevState.pagination, {
          page: 1
        })
      });
    });
  }, [setStateAndQuery]);

  var handleChangeOrder = _react.default.useCallback(function (nextOrder) {
    setStateAndQuery(function (prevState) {
      return (0, _extends2.default)({}, prevState, {
        order: nextOrder,
        pagination: (0, _extends2.default)({}, prevState.pagination, {
          page: 1
        })
      });
    });
  }, [setStateAndQuery]);

  _react.default.useEffect(function () {
    if (taxonomyCode !== prevTaxonomyCode) {
      setStateAndQuery(function () {
        return (0, _extends2.default)({}, defaultState, {
          prevTaxonomyCode: taxonomyCode
        });
      });
    }
  }, [handleResetFilter, prevTaxonomyCode, setStateAndQuery, taxonomyCode]);

  return {
    filter: filter,
    handleChangeFilter: handleChangeFilter,
    handleChangeOrder: handleChangeOrder,
    handleChangePage: handleChangePage,
    handleChangeRowsPerPage: handleChangeRowsPerPage,
    handleChangeStockOnly: handleChangeStockOnly,
    handleResetFilter: handleResetFilter,
    order: order,
    pagination: pagination,
    stockOnly: stockOnly
  };
}

var _default = useProductListState;
exports.default = _default;